export const SERVER_URL = "https://do-calculate.com/api";

export const Money_Zakat_EndPoint = "calculate-money-zakat";
export const Gold_Zakat_EndPoint = "calculate-gold-zakat";
export const Gold_Karat_EndPoint = "calculate-gold-karat";
export const Silver_Zakat_EndPoint = "calculate-silver-zakat";
export const Fruits_Zakat_EndPoint = "calculate-fruits-zakat";
export const Trade_Zakat_EndPoint = "calculate-trade-zakat";
export const Animals_Zakat_EndPoint = "calculate-animals-zakat";
export const islamicCalculators = [
  {
    name: "Kalkulator Zakat Harta",
    link: "/calculator/id/money-zakat/",
    description:
      "Kalkulator ini digunakan untuk menghitung zakat harta dan sedekah berdasarkan aturan Islam.",
      showMain: true
  },
  {
    name: "Kalkulator Zakat Emas",
    link: "/calculator/id/gold-zakat/",
    description:
      "Kalkulator ini menghitung zakat emas dan perhiasan berdasarkan ketentuan syariat.",
      showMain: true
  },
  {
    name: "Kalkulator Zakat Perak",
    link: "/calculator/id/silver-zakat/",
    description:
      "Kalkulator ini digunakan untuk menghitung zakat perak dan logam mulia berdasarkan hukum Islam.",
      showMain: true
  },
  {
    name: "Kalkulator Zakat Buah-buahan",
    link: "/calculator/id/fruits-zakat/",
    description:
      "Kalkulator ini menghitung zakat buah-buahan dan hasil pertanian sesuai dengan ketentuan agama.",
      showMain: true
  },
  {
    name: "Kalkulator Zakat Perdagangan",
    link: "/calculator/id/trade-zakat/",
    description:
      "Kalkulator ini digunakan untuk menghitung zakat barang dagangan dan dana investasi.",
      showMain: true
  },
  {
    name: "Kalkulator Zakat Hewan",
    link: "/calculator/id/animals-zakat/",
    description:
      "Kalkulator ini menghitung zakat hewan dan ternak berdasarkan ketentuan syariat.",
  },
  {
    name: "Kalkulator Konversi Karat Emas",
    link: "/calculator/id/gold-karat/",
    description:
      "Kalkulator ini digunakan untuk mengkonversi satuan karat emas ke satuan lain seperti gram dan ons.",
      showMain: true
  },
  {
    name: "Kalkulator Shalat Tahajud",
    link: "/calculator/id/tahajjud-time/",
    description:
      "Kalkulator ini digunakan untuk menghitung waktu shalat tahajud berdasarkan waktu shalat maghrib dan subuh.",
      showMain: true
  },
  // evening-athkar
  {
    name: "Dzikir Petang",
    link: "/calculator/id/athkar-almasaa/",
    description: "Lihat dzikir petang dengan penghitung digital yang membantu Anda melacak tasbih dan dzikir harian dengan mudah dan ringan.",
  },
  // athkar-alsabah
  {
    name: "Dzikir Pagi",
    link: "/calculator/id/athkar-alsabah/",
    description: "Lihat dzikir pagi dengan penghitung digital yang membantu Anda melacak tasbih dan dzikir harian dengan mudah dan ringan.",
  }, 
];
export default islamicCalculators;